import { render, staticRenderFns } from "./TDS.vue?vue&type=template&id=747d4054&scoped=true&"
import script from "./TDS.vue?vue&type=script&lang=js&"
export * from "./TDS.vue?vue&type=script&lang=js&"
import style0 from "./TDS.vue?vue&type=style&index=0&id=747d4054&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747d4054",
  null
  
)

export default component.exports